import React, {Component} from "react";
import {Link} from 'react-router-dom';
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";
/*
    Importing Notice for dismissable alerts
*/
import Notice from "./partials/Notice";

/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();
/*
    Dashboard view that displays the Dashboard pages
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class Application extends Component {
  constructor(){
    super();

    this.dismissNotice = this.dismissNotice.bind(this);
    this.editInfo = this.editInfo.bind(this);
    this.togglePreferences = this.togglePreferences.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleEmailKeyUp = this.handleEmailKeyUp.bind(this);
    this.handlePhoneKeyUp = this.handlePhoneKeyUp.bind(this);
    this.editInfo = this.editInfo.bind(this);
  }
  componentDidMount() {
    this.props.updateForm("pagename", "Application");
    this.props.setPage("application");
    //For Testing Purposes
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");
      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");
      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");
      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("bday", "12/06/1960");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("nextpay", "07/13/2018");
      this.props.updateForm("bank", "Bank of America");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");
      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }
  }

  editInfo(e){
    // if (e.target.parentNode.classList.contains('editpen')){
    //   e.target.parentNode.parentNode.classList.add("hidden");
    //   e.target.parentNode.parentNode.nextSibling.classList.remove("hidden");
    // } else {
    //   e.target.parentNode.classList.add("hidden");
    //   e.target.parentNode.nextSibling.classList.remove("hidden");
    // }
  }

  handleEmailChange(e) {
    let email = e.target.value;
    this.props.updateForm("eml", email);

    let emltip = document.getElementById("emltip");
    const emaillabel = document.querySelector("label[for='eml']");

    if (validation.validateEmail(email)) {
      this.emailchecked = true;
      emltip.innerHTML = "";
      emltip.classList.add("hidden");
      emaillabel.classList.add("active");
    } else {
      this.emailchecked = false;
      emaillabel.classList.remove("active");
    }
    this.props.updateForm("allchecked", validation.checkAll([true,this.emailchecked,this.passwordchecked,this.econsentchecked]));
  }

  handleEmailKeyUp(e) {
    // eslint-disable-next-line
    if(e.keyCode == 13){
      let emltip = document.getElementById("emltip");
      const emaillabel = document.querySelector("label[for='eml']");

      if (validation.validateEmail(this.props.eml)) {
        this.emailchecked = true;
        emltip.innerHTML = "";
        emltip.classList.add("hidden");
        emaillabel.classList.add("active");
        document.getElementById("emlfield").classList.add("hidden");
        document.getElementById("emlbox").classList.remove("hidden");
      } else {
        this.emailchecked = false;
        emaillabel.classList.remove("active");
      }
      this.props.updateForm("allchecked", validation.checkAll([true,this.emailchecked,this.passwordchecked,this.econsentchecked]));
    }

  }

  handleEmailBlur(e) {
    let email = e.target.value;
    let emltip = document.getElementById("emltip");

    if (!validation.validateEmail(email)) {
      emltip.innerHTML = email + " is not a valid email.";
      emltip.classList.remove("hidden");
    } else {
      document.getElementById("emlfield").classList.add("hidden");
      document.getElementById("emlbox").classList.remove("hidden");
    }
  }

  handlePhoneKeyUp(e) {
    // eslint-disable-next-line
    if(e.keyCode == 13){
      let phntip = document.getElementById("phntip");
      const phnlabel = document.querySelector("label[for='phn']");

      if (validation.validatePhone(this.props.phn)){
        phntip.classList.add("hidden");
        phntip.innerHTML = "";
        phnlabel.classList.add("active");
        document.getElementById("phnfield").classList.add("hidden");
        document.getElementById("phnbox").classList.remove("hidden");
      } else {
        phnlabel.classList.remove("active");
      }
    }
  }

  handlePhoneChange(e) {
    let phn = e.target.value;

    phn = phn.replace(/\D/g, '');
    let split = 3;
    let chunk = [];
    for (let i = 0; i < phn.length; i += split) {
      split = (i <= 3) ? 3 : 4;
      chunk.push( phn.substr( i, split ) );
    }
    if (chunk[0]) chunk[0] = validation.checkPhoneNum(chunk[0], 200);
    let tmp = chunk.join("-");
    this.props.updateForm("phn", tmp);

    let phntip = document.getElementById("phntip");
    const phnlabel = document.querySelector("label[for='phn']");

    if (validation.validatePhone(phn)){
      phntip.classList.add("hidden");
      phntip.innerHTML = "";
      phnlabel.classList.add("active");
    } else {
      phnlabel.classList.remove("active");
    }
  }

  handlePhoneBlur(e) {
    let phn = e.target.value;
    let phntip = document.getElementById("phntip");

    if (!validation.validatePhone(phn)){
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter a valid phone number.";
    } else {
      document.getElementById("phnfield").classList.add("hidden");
      document.getElementById("phnbox").classList.remove("hidden");
    }
  }


  togglePreferences(e){
    let preferences = document.getElementById("preferences");
    if (preferences.classList.contains('hidden')){
      preferences.classList.remove("hidden");
    } else {
      preferences.classList.add("hidden");
    }
  }

  dismissNotice(e){
    document.getElementById("dismissnotice").classList.add("hidden");
    this.props.updateForm("noticedismissed", true);
  }

  render() {

    const hiddenssn = "XXX-XX-"+this.props.ssn[5]+this.props.ssn[6]+this.props.ssn[7]+this.props.ssn[8];

    return (
      <div id="dashboard2">
        <div className="dashheader">
          {this.props.pagename}
        </div>

        { !this.props.noticedismissed && <Notice /> }

        <div className="dashmain">
          <div className="text-center">
            <h1 className="ptop">New Application</h1>
            <p>Please confirm your information below to get started on your application.</p>
          </div>
          <div className="padtop" style={{boxShadow:'0 4px 10px rgba(0, 0, 0, 0.5)',borderRadius:'4px'}}>
            <div className="detailsbox" style={{borderLeft:'none',marginBottom:'0',paddingBottom:'3px',paddingTop:'10px',borderTopLeftRadius:'4px',borderTopRightRadius:'4px'}}>
              <div id="personalbox">
                <svg style={{top:'16px',right:'16px'}} className="editpen" onClick={this.editInfo} width="12px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                  <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                </svg>

                <h4>Personal Information</h4>
                <p><strong>Name:</strong> {this.props.fn} {this.props.ln}</p>
                <p><strong>Address: </strong> {this.props.street}<br />{this.props.city}, {this.props.stt}, {this.props.zip}</p>
                <p><strong>Phone:</strong> {this.props.phn}</p>
                <p><strong>SSN:</strong> {hiddenssn}</p>
                <p><strong>DOB:</strong> {this.props.bday}</p>
              </div>
              <div id="personalfields">

              </div>

              <hr />

            </div>

            <div className="detailsbox" style={{borderLeft:'none',marginBottom:'0',paddingBottom:'1px',paddingTop:'0px'}}>
              <div id="incomebox">
                <svg style={{top:'-9px',right:'16px'}} className="editpen" onClick={this.editInfo} width="12px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                  <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                </svg>

                <h4 style={{marginTop:'0'}}>Income Information</h4>
                <p><strong>Pay Frequency: </strong> {this.props.payfrequency}</p>
                <p><strong>Paycheck Amount:</strong> {this.props.payamount}</p>
                <p><strong>Next Pay Date:</strong> {this.props.nextpay}</p>
              </div>
              <div id="incomefields">

              </div>

              <hr />
            </div>

            <div className="detailsbox" style={{borderLeft:'none',paddingTop:'1px',paddingBottom:'15px',borderBottomLeftRadius:'4px',borderBottomRightRadius:'4px'}}>
              <div id="bankbox">
                <svg style={{top:'-9px',right:'16px'}} className="editpen" onClick={this.editInfo} width="12px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                  <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                </svg>

                <h4 style={{marginTop:'3px'}}>Bank Information</h4>
                <p><strong>Bank Name:</strong> {this.props.bank}</p>
                <p><strong>Routing Number:</strong> {this.props.routingnum}</p>
                <p><strong>Account Number:</strong> {this.props.bankaccount}</p>
                <p><strong>Type of Account:</strong> {this.props.accounttype}</p>
              </div>
              <div id="bankfields">

              </div>
            </div>
          </div>

          <div className="text-center padtop30">
            <a className="btn last-step padtop padbottom">Submit</a>
            <Link to="/dashboard">Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    fn: state.FormReducer.fn,
    ln: state.FormReducer.ln,
    address: state.FormReducer.address,
    street: state.FormReducer.street,
    city: state.FormReducer.city,
    st: state.FormReducer.st,
    stt: state.FormReducer.stt,
    zip: state.FormReducer.zip,
    eml: state.FormReducer.eml,
    phn: state.FormReducer.phn,
    ismobile: state.FormReducer.ismobile,
    ssn: state.FormReducer.ssn,
    bday: state.FormReducer.bday,
    co: state.FormReducer.co,
    cophn: state.FormReducer.cophn,
    payfrequency: state.FormReducer.payfrequency,
    payamount: state.FormReducer.payamount,
    nextpay: state.FormReducer.nextpay,
    bank: state.FormReducer.bank,
    accounttype: state.FormReducer.accounttype,
    bankaccount: state.FormReducer.bankaccount,
    routingnum: state.FormReducer.routingnum,
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    noticedismissed: state.FormReducer.noticedismissed,
    accountnumber: state.FormReducer.accountnumber,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/Application.js